module.exports = __webpack_public_path__ + "img/help_lines_final_lazy.26325d52.jpg";